import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import Checkbox from '@jimmyboys/liita-ui/dist/components/Checkbox'
import Dropdown from '@jimmyboys/liita-ui/dist/components/Dropdown'
import React from 'react'
import { useFieldArray } from 'react-hook-form'

import styles from './HFInputs.module.sass'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import { lateralityOptions } from 'controllers/TaskManager/formOptions'

const HFQuantitiesGroup = (props) => {
	const {
		name,
		data,
		tint,
		booleanInput = false,
		hasLaterality = false,
	} = props
	const { fields, update } = useFieldArray({
		name,
		keyName: 'key',
	})

	return (
		<VStack className={styles['quantity-input-container']}>
			{fields.map(({ key, ...field }, index) => {
				const option = data?.[index]

				let isSurgery = !!option?.kValue

				const value = parseInt(field.value, 10) || 0

				const maxValue = option?.requestedQuantity
					? option?.requestedQuantity
					: isSurgery
					? 100
					: 0

				return (
					<HStack
						key={index}
						className={`${styles['quantity-input']} ${
							!field.checked ? styles['--not-checked'] : ''
						} ${field.disabled ? styles['--disabled'] : ''}`}
						gap='xsmall'
						align='center'
					>
						<span className={styles['checkbox-container']}>
							<Checkbox
								tint={tint}
								className={`${styles['checkbox']} ${
									!field.checked ? styles['unchecked'] : ''
								}`}
								checked={field.checked}
								onChange={(event) => {
									const result = {
										...field,
										checked: event.target.checked,
									}
									if (!booleanInput) {
										result.value = event.target.checked
											? maxValue
											: 0
									}

									update(index, result)
								}}
							/>
						</span>

						<VStack className={styles['label-container']}>
							<h5>{option?.code ? `${option?.code} ` : ''}</h5>
							<small className={styles['label-description']}>
								{option?.description || option?.name}
							</small>
						</VStack>

						{hasLaterality && (
							<Dropdown
								className={`${styles['laterality-selector']}`}
								value={field.laterality}
								options={lateralityOptions}
								onChange={(event) => {
									const result = {
										...field,
										laterality: event.target.value,
									}
									update(index, result)
								}}
								searchable={true}
							/>
						)}

						{!booleanInput && (
							<HStack className={styles['input-container']}>
								{isSurgery && (
									<small className='nowrap'>
										{`${
											option?.kValue
												? `K: ${option?.kValue}`
												: ''
										}`}
									</small>
								)}

								<HStack
									className={
										styles['percentage-input-container']
									}
								>
									<input
										className={`${styles['input']}`}
										type='text'
										inputMode='numeric'
										size={Math.max(
											4,
											option?.requestedQuantity
												? option?.requestedQuantity.toString()
														.length + 2
												: 0
										)}
										value={value}
										onChange={(event) => {
											const value = parseInt(
												event.target.value,
												10
											)
											update(index, {
												...field,
												value: Math.min(
													value,
													maxValue
												),
												checked: value > 0,
											})
										}}
									/>
									{isSurgery ? (
										<span>%</span>
									) : (
										<small>
											{`/ ${
												option?.requestedQuantity ?? 0
											}`}
										</small>
									)}
								</HStack>
							</HStack>
						)}
					</HStack>
				)
			})}
		</VStack>
	)
}

export default HFQuantitiesGroup
